import React from 'react'
import { Box, Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../../constants/colors'
import { MediaPermissionStatus } from '../../../shared/components/MediaPermissionStatus'
import { useTranslation } from '../../../shared/hooks/useIntractionTranslate'

export const ProfileMediaPermissionsSection: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        padding: '24px',
        backgroundColor: INTERAX_COLORS.heritageBlue40,
        borderRadius: '12px',
        marginBottom: '24px'
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontSize: '20px',
          fontWeight: 600,
          color: INTERAX_COLORS.white,
          marginBottom: '16px'
        }}
      >
        {t('facilitator.profile.mediaPermissions')}
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          color: INTERAX_COLORS.thunderGrey,
          marginBottom: '16px'
        }}
      >
        {t('facilitator.profile.mediaPermissionsDescription')}
      </Typography>
      <MediaPermissionStatus />
    </Box>
  )
}
